export { default } from './SearchMatch';
